// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mx-datepicker[data-v-2878435c]{width:250px}", "",{"version":3,"sources":["webpack://./src/components/Questions/QuestionDate.vue"],"names":[],"mappings":"AACA,gCAEC,WAAA","sourcesContent":["\n.mx-datepicker {\n\t// Enlarging a bit (originally 210px) to have enough space for placeholder\n\twidth: 250px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
